document.addEventListener("DOMContentLoaded", function () {
    const PASSWORD = "befroh"; // <-- replace with your password
    const eventsList = document.getElementById("EventsLists").querySelector("tbody");
    const today = new Date().toISOString().split("T")[0];

    // Check if password was already entered this session
    if (sessionStorage.getItem("events_password_verified") === "true") {
        loadEvents();
    } else {
        const password = prompt("Enter the password to view events:");
        if (password === PASSWORD) {
            sessionStorage.setItem("events_password_verified", "true");
            loadEvents();
        } else {
            window.location.href = "/";
        }
    }

    function formatDateDisplay(dateStr) {
        const date = new Date(dateStr);
        return date
            .toLocaleDateString("lt-LT", { day: "numeric", month: "long", year: "numeric" })
            .replace(" d.", "");
    }

    function loadEvents() {
        fetch("https://littlewhile.rav.lt/wp-admin/admin-ajax.php?action=get_all_events")
            .then((res) => res.json())
            .then((data) => {
                console.log("[Events] Raw response:", data); // <-- full payload
                eventsList.innerHTML = "";

                if (data.success && Array.isArray(data.data) && data.data.length > 0) {
                    data.data.forEach((ev, idx) => {
                        console.log(`[Events] item ${idx}:`, ev); // <-- each event object

                        const isToday = ev.event_date === today;
                        const displayDate = formatDateDisplay(ev.event_date);

                        // Try common email fields; adjust after checking console output
                        const email =
                            ev.email ??
                            ev.customer_email ??
                            (ev.customer && ev.customer.email) ??
                            "(no email)";

                        eventsList.innerHTML += `
                            <tr class="occasion-item${isToday ? " date-today" : ""}">
                                <td class="dot-legend"><span></span></td>
                                <td class="date-display">${displayDate}</td>
                                <td class="title-display">${ev.title ?? ""}</td>
                                <td class="for-display">${ev.for_who ?? ""}</td>
                                <td class="user-display">${email}</td>
                            </tr>`;
                    });
                } else {
                    console.warn("[Events] No events found or unexpected format.");
                    eventsList.innerHTML = "<tr><td colspan='5'>No events found.</td></tr>";
                }
            })
            .catch((err) => {
                console.error("[Events] Fetch error:", err);
                eventsList.innerHTML = "<tr><td colspan='5'>Error loading events.</td></tr>";
            });
    }
});
